import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { Helper } from '../helper.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ApplicationAPIService {
  options: any;

  constructor(
    private http: HttpClient,
    private helperService: Helper,
  ) {}

  getApplications(): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.get(environment.applicationServiceEndPoint, this.options).pipe(catchError(this.helperService.handleError));
  }
}
